export default {
	name: 'statsSection',
	title: 'Stats Section',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Section Title',
			type: 'string',
		},
		{
			name: 'subtitle',
			title: 'Section Subtitle',
			type: 'text',
		},
		{
			name: 'stats',
			title: 'Statistics',
			type: 'array',
			of: [
				{
					type: 'stat',
				},
			],
		},
	],
};
